/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  TimetableEventAttachment,
  TimetableEventAttachmentRequestInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Event Attachment
 */
export const createTimetableEventAttachment = (
    calendarId: MaybeRefOrGetter<string>,
    eventId: MaybeRefOrGetter<string>,
    timetableEventAttachmentRequestInput: MaybeRefOrGetter<TimetableEventAttachmentRequestInput>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
eventId = toValue(eventId);
timetableEventAttachmentRequestInput = toValue(timetableEventAttachmentRequestInput);

      return axiosClient<TimetableEventAttachment>(
      {url: `/timetable/calendars/${calendarId}/events/${eventId}/attachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timetableEventAttachmentRequestInput, signal
    },
      );
    }




export const getCreateTimetableEventAttachmentMutationKey = () => ['createTimetableEventAttachment'] as const;

export const getCreateTimetableEventAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableEventAttachment>>, TError,CreateTimetableEventAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTimetableEventAttachment>>, TError,CreateTimetableEventAttachmentMutationVariables, TContext> => {

const mutationKey = getCreateTimetableEventAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTimetableEventAttachment>>, CreateTimetableEventAttachmentMutationVariables> = (props) => {
          const {calendarId,eventId,data} = props ?? {};

          return  createTimetableEventAttachment(calendarId,eventId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTimetableEventAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createTimetableEventAttachment>>>
    export type CreateTimetableEventAttachmentMutationBody = TimetableEventAttachmentRequestInput
    export type CreateTimetableEventAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateTimetableEventAttachmentMutationVariables = {calendarId: string;eventId: string;data: TimetableEventAttachmentRequestInput}

    /**
 * @summary Create Event Attachment
 */
export const useCreateTimetableEventAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableEventAttachment>>, TError,CreateTimetableEventAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTimetableEventAttachment>>,
        TError,
        CreateTimetableEventAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTimetableEventAttachmentMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Event Attachment
 */
export const deleteTimetableEventAttachment = (
    calendarId: MaybeRefOrGetter<string>,
    eventId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
eventId = toValue(eventId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${calendarId}/events/${eventId}/attachments/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteTimetableEventAttachmentMutationKey = () => ['deleteTimetableEventAttachment'] as const;

export const getDeleteTimetableEventAttachmentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableEventAttachment>>, TError,DeleteTimetableEventAttachmentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableEventAttachment>>, TError,DeleteTimetableEventAttachmentMutationVariables, TContext> => {

const mutationKey = getDeleteTimetableEventAttachmentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTimetableEventAttachment>>, DeleteTimetableEventAttachmentMutationVariables> = (props) => {
          const {calendarId,eventId,id} = props ?? {};

          return  deleteTimetableEventAttachment(calendarId,eventId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTimetableEventAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTimetableEventAttachment>>>

    export type DeleteTimetableEventAttachmentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteTimetableEventAttachmentMutationVariables = {calendarId: string;eventId: string;id: string}

    /**
 * @summary Delete Event Attachment
 */
export const useDeleteTimetableEventAttachment = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableEventAttachment>>, TError,DeleteTimetableEventAttachmentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTimetableEventAttachment>>,
        TError,
        DeleteTimetableEventAttachmentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTimetableEventAttachmentMutationOptions(options), queryClient);
    }
